/**
 * LanguageSelector — Toggle between en/es for i18n
 */
import React from 'react';
import { IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const LOCALES = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
];

export default function LanguageSelector({ size = 'medium' }) {
  const { i18n } = useTranslation();
  const [anchor, setAnchor] = React.useState(null);

  const handleOpen = (e) => setAnchor(e.currentTarget);
  const handleClose = () => setAnchor(null);
  const handleSelect = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem('locale', code);
    handleClose();
  };

  return (
    <>
      <IconButton onClick={handleOpen} size={size} aria-label="Select language">
        <LanguageIcon />
      </IconButton>
      <Menu anchorEl={anchor} open={!!anchor} onClose={handleClose}>
        {LOCALES.map(({ code, label }) => (
          <MenuItem key={code} onClick={() => handleSelect(code)} selected={i18n.language.startsWith(code)}>
            <Typography variant="body2">{label}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
